import {
    Alert,
    AlertIcon,
    Box,
    Button,
    Drawer,
    DrawerBody,
    DrawerCloseButton,
    DrawerContent,
    DrawerFooter,
    DrawerHeader,
    DrawerOverlay,
    Flex,
    Kbd,
    Tag,
    TagLabel,
    Text,
    useDisclosure,
} from '@chakra-ui/react';
import { useCallback, useState } from 'react';

import { usePortfolio } from '../../api/portfolio';
import { PortfolioTabs } from '../PortfolioTabs';

export const PortfolioDrawer = ({
    isOpen,
    onClose,
    pId,
    defaultIndex,
}: {
    isOpen: boolean;
    onClose: () => void;
    pId?: string;
    defaultIndex?: number;
}) => {
    const { data } = usePortfolio({ pId });

    return (
        <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="huge">
            <DrawerOverlay />
            <DrawerContent>
                <DrawerCloseButton />

                <DrawerHeader borderBottomWidth={1}>
                    <Flex gap={4} overflow="hidden">
                        <Text flexShrink={0}>Portfolio details</Text>

                        <Flex alignItems="center" gap={1}>
                            <Tag size="md" flexShrink={0}>
                                <TagLabel>{data?.base?.accountAlias}</TagLabel>
                            </Tag>
                            <Tag size="md" flexShrink={0}>
                                <TagLabel>{data?.base?.portfolioGuid}</TagLabel>
                            </Tag>
                            <Tag size="md" flexShrink={0}>
                                <TagLabel>
                                    {data?.base?.brokerId}:{data?.base?.aC}
                                </TagLabel>
                            </Tag>
                        </Flex>
                    </Flex>
                </DrawerHeader>

                {data?.base && (
                    <DrawerBody px={0} pt={0}>
                        <PortfolioTabs pId={data.base.pId} defaultIndex={defaultIndex} />
                    </DrawerBody>
                )}

                <DrawerFooter gap={4} justifyContent="space-between">
                    <Box>
                        <Alert status="info" fontSize="xs">
                            <AlertIcon boxSize={4} />
                            <Text>
                                You can close this panel by hitting <Kbd>Esc</Kbd> or clicking the backdrop
                            </Text>
                        </Alert>
                    </Box>
                    <Button variant="outline" onClick={onClose} flexShrink={0}>
                        Close
                    </Button>
                </DrawerFooter>
            </DrawerContent>
        </Drawer>
    );
};

export const usePortfolioDrawerControls = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [pId, setPId] = useState<string | undefined>();

    const viewPortfolio = useCallback(
        (portfolio: string) => {
            setPId(portfolio);
            onOpen();
        },
        [onOpen],
    );

    return {
        viewPortfolio,
        isOpen,
        onClose,
        pId,
    };
};
